export type EventTypeString = 'OPENING_FINISHED';

export const eventType: EventTypeString = 'OPENING_FINISHED';

export type EventType = {
  type: EventTypeString,
};

export const eventBuilder = (): EventType => ({
  type: eventType,
});
